import React from 'react';
import {useIntl} from 'react-intl';
import {AttentionIcon} from './AttentionIcon';
import {DeclinedIcon} from './DeclinedIcon';
import {DoneCheckmarkIcon} from './DoneCheckmarkIcon';

type HarvestStatusIconProps = {
	timeReg: {
		harvestTask?: unknown;
		harvestTaskIdInt?: unknown;
		harvestTimeId?: unknown;
		harvestError?: string;
	};
};

export function HarvestStatusIcon({timeReg}: HarvestStatusIconProps): React.JSX.Element {
	const {formatMessage} = useIntl();

	if (timeReg.harvestTask || timeReg.harvestTaskIdInt) {
		if (timeReg.harvestTimeId) {
			return (
				<DoneCheckmarkIcon
					className="harvest-sync-icon"
					title={formatMessage({id: 'task_modal.harvest_registration_synced'})}
				/>
			);
		} else if (timeReg.harvestError) {
			return <DeclinedIcon className="harvest-sync-icon" title={timeReg.harvestError} />;
		} else {
			return (
				<AttentionIcon
					className="harvest-sync-icon"
					title={formatMessage({id: 'task_modal.harvest_registration_not_synced'})}
				/>
			);
		}
	} else {
		return (
			<DeclinedIcon
				className="harvest-sync-icon"
				title={formatMessage({id: 'task_modal.harvest_registration_unable_sync'})}
			/>
		);
	}
}
